import React from 'react';
import { OuterWrapper, AspectRatioMain, AspectRatioInner } from './styles';
var AspectRatio = function (_a) {
    var children = _a.children, ratio = _a.ratio, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight;
    if (!ratio) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement(OuterWrapper, { maxWidth: maxWidth, maxHeight: maxHeight },
        React.createElement(AspectRatioMain, { ratio: ratio, maxHeight: maxHeight },
            React.createElement(AspectRatioInner, null, children))));
};
export default AspectRatio;
//# sourceMappingURL=AspectRatio.js.mapimport React from 'react';
import { OuterWrapper, AspectRatioMain, AspectRatioInner } from './styles';
var AspectRatio = function (_a) {
    var children = _a.children, ratio = _a.ratio, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight;
    if (!ratio) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement(OuterWrapper, { maxWidth: maxWidth, maxHeight: maxHeight },
        React.createElement(AspectRatioMain, { ratio: ratio, maxHeight: maxHeight },
            React.createElement(AspectRatioInner, null, children))));
};
export default AspectRatio;
//# sourceMappingURL=AspectRatio.js.map